/* eslint-disable no-unsafe-optional-chaining */
/* eslint-disable import/no-unresolved */
import moment from "moment";
import StorageService from "src/utils/Storage/storageService";
import { roleIDs } from "src/config/constant";
import { OPTIONS } from "./resources";
import { ProductNameMapper, products } from "../FormDetails/resources";
import { statusToBucketStringMap } from ".";

const columnHeadings = () => {
  const user = StorageService.getFromLocalStorage("user");
  return [
    // --- Proposal/Application Details ---
    // { name: "priorityOrder", label: "Priority Order", filterSort: true },
    { name: "applicationNo", label: "Bank App. No.", filterSort: true },
    { name: "clcApplicationNo", label: "CLC App. No.", filterSort: false },
    { name: "proposalStatus", label: "Proposal \n Status", filterSort: false },
    { name: "ibpsStatus", label: "IBPS Status", filterSort: false },
    { name: "proposalReceivedDate", label: "Created on \n (DD-MM-YYYY)", filterSort: true },
    { name: "ageing", label: "Ageing (in days)", filterSort: false },
    // --- Customer Details ---
    { name: "lifeInsurerName", label: "Customer Name", filterSort: true },
    { name: "lifeInsurerGender", label: "Life Assured Gender", filterSort: false },
    { name: "lifeInsurerEmail", label: "Life Assured Email", filterSort: false },
    { name: "mobile", label: "Mobile No.", filterSort: false },
    { name: "nationality", label: "Nationality", filterSort: false },
    { name: "lifeInsurerDob", label: "DOB \n (DD-MM-YYYY)", filterSort: true },

    // --- Loan Details ---
    { name: "loanAccNo", label: "Loan Acc. No.", filterSort: false },
    { name: "loanAmount", label: "Loan Amount", filterSort: false },
    { name: "term", label: "Loan Term", filterSort: false },
    { name: "typeOfLoan", label: "Loan Type", filterSort: false },
    { name: "funding", label: "Funding Type", filterSort: false },
    { name: "loanStatus", label: "Loan Status", filterSort: false },
    { name: "solId", label: "Sol ID", filterSort: true },

    // --- Policy/Plan Details ---
    { name: "planOptionOpted", label: "Plan Option opted", filterSort: false },
    // { name: "policyTerm", label: "Policy Term", filterSort: false },
    { name: "term", label: "Policy Term", filterSort: true },
    { name: "premiumPaymentTerm", label: "Premium Payment Term", filterSort: false },
    { name: "sumAssured", label: "Sum Assured \n (in Rs.)", filterSort: true },
    { name: "totalpremium", label: "Premium \n (in Rs.)", filterSort: true },

    // --- Payment Details ---
    { name: "paymentStatus", label: "Payment Status", filterSort: false },
    // { name: "amountPaid", label: "Amount Paid \n (in Rs.)", filterSort: true },
    { name: "productName", label: "Product Name", filterSort: false },

    // --- Agent/Intermediary Details ---
    // { name: "irmName", label: "IRM Name", filterSort: false },
    { name: "employeeCode", label: "Agent Code", filterSort: false },
    // { name: "intermediaryName", label: "Intermediary Name", filterSort: false },

    // --- Master Policy Details ---
    { name: "mphName", label: "MPH Name", filterSort: false },
    { name: "mphNumber", label: "MPH Number", filterSort: false },
    // { name: "requirementStatus", label: "Requirement Status", filterSort: false },

    // --- Partner/Source ---
    ...(user?.role !== roleIDs.bankEmployee || user?.role !== roleIDs.partnerAdmin
      ? [{ name: "partner", label: "Partner", filterSort: false }]
      : []),
    {
      name: "riderName",
      label: "Rider Name",
      filterSort: false
    },
    {
      name: "riderSumAssured",
      label: "Rider Sum Assured",
      filterSort: false
    },
    {
      name: "riderPolicyTerm",
      label: "Rider Policy Term"
    },
    {
      name: "amountPaid",
      label: "Amount Paid \n (in Rs.)",
      filterSort: true
    },
    { name: "requirementStatus", label: "Requirement Status", filterSort: false },
    { name: "irmName", label: "IRM Name", filterSort: true },
    // {
    //   name: "action",
    //   label: "Action",
    //   filterSort: false
    // },
    {
      name: "riderPremuimPaymentTerm",
      label: "Rider Premuim Payment Term",
      filterSort: false
    },
    { name: "source", label: "Source", filterSort: false },

    // --- Decision/Workflow ---
    { name: "sparkDecision", label: "Spark Decision", filterSort: false },
    ...(user?.role === roleIDs.superAdmin
      ? [{ name: "workflow", label: "Workflow", filterSort: false }]
      : []),

    // --- Utility/Actions ---
    { name: "action", label: "Action", filterSort: false },
    { name: "formType", label: "Form Type", filterSort: false },
    { name: "download", label: "Download", filterSort: false },
    { name: "caseReassign", label: "Case Reassign", filterSort: false }
  ];
};
const rowData = (data: any) => {
  const user = StorageService.getFromLocalStorage("user");
  const obj: Record<string, any> = {};
  data?.data?.forEach((row: any) => {
    const currentRow = {
      applicationNo: row?.applicationNo || "-",
      clcApplicationNo: row?.clcAppNo || "-",
      lifeInsurerName: row?.lifeInsurerName || "-",
      lifeInsurerGender: row?.lifeInsurerGender || "-",
      lifeInsurerEmail: row?.lifeInsurerEmail || "-",
      mobile: row?.mobile || "-",
      nationality:
        OPTIONS.nationality[row?.lifeInsurerNationality || "RES"] || OPTIONS.nationality.RES,
      lifeInsurerDob:
        (row?.lifeInsurerDob && moment(row?.lifeInsurerDob).format("DD-MM-YYYY")) || "-",
      loanAccNo: row?.loanAccountNo || "-",
      proposalStatus: row?.proposalStatus || "-",
      ibpsStatus: statusToBucketStringMap[row?.ibpsStatus] || "-",
      loanStatus: row?.loanStatus || "-",
      solId: row?.solId || "-",
      sumAssured: Number(row?.sumAssured).toLocaleString("en-IN") || "-",
      term:
        (row?.policyTerm &&
          `${row?.policyTerm} ${
            [
              products?.GHS,
              products?.GHS_FOR_JIO,
              products?.GHS_IDBI,
              products?.GCS,
              products?.GCS_SREI,
              products?.GCS_CAPRI,
              products?.GCS_SOLFIN
            ]?.includes(row.productId)
              ? "months"
              : "years"
          }`) ||
        "-",
      totalpremium: row?.riderFlag
        ? (Number(row?.totalpremium ?? 0) + Number(row?.riderPremium ?? 0)).toLocaleString(
            "en-IN"
          ) || "-"
        : Number(row?.totalpremium ?? 0).toLocaleString("en-IN") || "-",
      proposalReceivedDate:
        (row?.proposalReceivedDate && moment.utc(row?.proposalReceivedDate).format("DD-MM-YYYY")) ||
        "-",
      source: row?.source?.toUpperCase() || "-",
      ...((user?.role !== roleIDs.bankEmployee || user?.role !== roleIDs.partnerAdmin) && {
        partner: row?.partnerId?.toUpperCase() || "-"
      }),
      sparkDecision: row?.sparkFullDecision?.autoUnderwritingStatus?.description || "-",
      paymentStatus: row?.paymentStatus || "Pending",
      amountPaid: (row?.amountPaid && Number(row?.amountPaid).toLocaleString("en-IN")) || "-",
      riderName:
        row?.Riders?.map((r: { subPlanOption: any }) => r.subPlanOption || "-").join(", ") || "-",
      riderSumAssured:
        row?.Riders?.map((r: { sumAssured: any }) => r.sumAssured || "-").join(", ") || "-",
      riderPolicyTerm:
        row?.Riders?.map((r: { policyTerm: any }) => r.policyTerm || "-").join(", ") || "-",
      riderPremuimPaymentTerm:
        row?.Riders?.map((r: { premiumPaymentTerm: any }) => r.premiumPaymentTerm || "-").join(
          ", "
        ) || "-",
      requirementStatus: row?.followUpRequirements?.every(
        (item: { code?: string; status?: string }) => item?.status === "R"
      )
        ? "Received"
        : "Pending",
      irmName: row?.QuoteIrmMapping?.irmName || "-",
      action: row?.proposerBucket || "",
      formType: "BI",
      download: "download",
      caseReassign: "",
      funding: row?.funding,
      ...(user?.role === roleIDs.superAdmin && {
        workflow: "workflow"
      }),
      canEditMEF: row?.canEditMEF,
      mphName: row?.masterPolicyHolderName || "-",
      mphNumber: row?.masterPolicyNumber || "-",
      planOptionOpted: row?.coverOption || "-",
      loanAmount: row?.loanAmount?.toLocaleString("en-IN") || "-",
      typeOfLoan: row?.typeOfLoan || "-",
      policyTerm: row?.policyTerm || "-",
      premiumPaymentTerm: row?.premiumPaymentTerm || "-",
      ageing: row?.proposalReceivedDate
        ? Math.floor(
            (new Date().getTime() - new Date(row?.proposalReceivedDate).getTime()) /
              (1000 * 60 * 60 * 24)
          )
        : "-",
      employeeCode: row?.employeeCode || "-",
      intermediaryName: row?.bankDistributorName || "-",
      requirementTab: "-", // Placeholder, update as needed
      masterPolicyHolderName: row?.masterPolicyHolderName || "-",
      masterPolicyNumber: row?.masterPolicyNumber || "-",
      priorityOrder: Number(row?.priorityOrder) >= 0 ? Number(row?.priorityOrder) : 4,
      productName: ProductNameMapper[row?.productId] || "-"
    };
    obj[row?.id] = currentRow;
  });
  return obj;
};

// const filterOptions: string[] = columnHeadings?.map((heading) => heading.label);
export { rowData, columnHeadings };
